// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Q86","toggleWrap":"styles_toggleWrap__24aLf","content":"styles_content__21l5l","selectAreaCode":"styles_selectAreaCode__Bp48L"};